import React from 'react';
import { Stack, TextField } from '@mui/material';
import { AppCard } from '@/components/app-card/app-card';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import { formatCurrencyNoUnit } from '@/lib/formatters';
import {
  calculateTotalAllocated,
  calculateAllocationPercentage,
  calculateUnallocated,
  calculateUnallocatedPercentage,
} from '../../calculations';
import { Department } from '../hooks/useDepartments';

interface GlobalBudgetAllocationProps {
  departmentsList: Department[];
  globalBudget: {
    original_currency_value: number;
    original_currency: string;
  } | null;
  globalBudgetLoading: boolean;
}

export const GlobalBudgetAllocation: React.FC<GlobalBudgetAllocationProps> = ({
  departmentsList,
  globalBudget,
  globalBudgetLoading,
}) => {
  const totalAllocated = parseFloat(calculateTotalAllocated(departmentsList));
  const globalBudgetValue = globalBudget?.original_currency_value || 0;

  return (
    <AppCard
      className="card100"
      title="Global Budget Allocation"
      icon={<BarChartOutlinedIcon color="primary" />}>
      <Stack spacing={2}>
        <Stack spacing={2} direction="row">
          <TextField
            label="Annual Global Budget"
            variant="outlined"
            disabled
            size="small"
            value={
              globalBudgetLoading
                ? 'Loading...'
                : globalBudget?.original_currency_value ? formatCurrencyNoUnit(globalBudget.original_currency_value) : 'No budget set'
            }
          />

          <TextField
            label="Budget Currency"
            variant="outlined"
            disabled
            size="small"
            value={
              globalBudgetLoading
                ? 'Loading...'
                : globalBudget?.original_currency || 'N/A'
            }
          />
        </Stack>

        <Stack spacing={2} direction="row">
          <TextField
            label="Allocated"
            variant="outlined"
            disabled
            size="small"
            value={formatCurrencyNoUnit(totalAllocated)}
          />

          <TextField
            label="Budget Allocation"
            variant="outlined"
            disabled
            size="small"
            value={calculateAllocationPercentage(
              totalAllocated,
              globalBudgetValue,
            )}
          />
        </Stack>

        <Stack spacing={2} direction="row">
          <TextField
            label="Unallocated"
            variant="outlined"
            disabled
            size="small"
            value={calculateUnallocated(totalAllocated, globalBudgetValue)}
          />

          <TextField
            label="Missing Allocation"
            variant="outlined"
            disabled
            size="small"
            value={calculateUnallocatedPercentage(
              totalAllocated,
              globalBudgetValue,
            )}
          />
        </Stack>
      </Stack>
    </AppCard>
  );
};
